import { render, staticRenderFns } from "./NavigationDesktop.vue?vue&type=template&id=04378131&scoped=true"
import script from "./NavigationDesktop.vue?vue&type=script&lang=js"
export * from "./NavigationDesktop.vue?vue&type=script&lang=js"
import style0 from "./NavigationDesktop.vue?vue&type=style&index=0&id=04378131&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04378131",
  null
  
)

export default component.exports